class CustomFeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const collectionGrid = document.querySelector('.collection');
    let allBtns = collectionGrid.querySelectorAll('.col_btn');
    let collections = collectionGrid.querySelectorAll('.product-grid-container');

    let databtn = allBtns[0].getAttribute('data-btn'),
      collectionG = collectionGrid.querySelector(`.product-grid-container[data-btn="${databtn}"]`);
      // collectionI = collectionGrid.querySelector(`.col_img[data-btn="${databtn}"]`);

      collectionG.classList.add('collection-active');
      // collectionI.classList.add('collection-active');
      allBtns[0].classList.add('collection-active');

    allBtns.forEach((btn) => {
        btn.addEventListener('click', (ev) => this.updateCollection(ev, btn, collectionGrid, collections));
    })
  }

  updateCollection(ev, btn, collectionGrid, collections){
    if (ev.target){
        let databtn = btn.getAttribute('data-btn'),
          collectionG = collectionGrid.querySelector(`.product-grid-container[data-btn="${databtn}"]`);
          // collectionI = collectionGrid.querySelector(`.col_img[data-btn="${databtn}"]`);

      if (btn.classList.contains('collection-active') == false) {
        collections.forEach((collection) => {
          collection.classList.remove('collection-active');
        });

        let btnR = collectionGrid.querySelector(`.col_btn.collection-active`);
        btnR.classList.remove('collection-active');
        btn.classList.add('collection-active');

        collectionG.classList.add('collection-active');


        // let collectionR = collectionGrid.querySelector(`.col_img.collection-active`);
        // collectionI.classList.add('collection-active');
        // collectionR.classList.remove('collection-active');
      }
    }
  }
}

customElements.define('custom-featured-collection', CustomFeaturedCollection);